(function () {
  function setVariant(root, button) {
    if (!button || button.disabled) return;
    root.querySelectorAll('[data-obp-band-option]').forEach(function (item) {
      var selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    var variantId = Number(button.dataset.variantId);
    var available = button.dataset.available === 'true';
    var price = button.dataset.price;
    var label = button.querySelector('strong')?.textContent?.trim() || '';
    root.dataset.variantId = String(variantId);
    var variantInput = root.querySelector('[data-obp-band-variant-input]');
    if (variantInput) variantInput.value = String(variantId);
    var priceNode = root.querySelector('[data-obp-band-price]');
    if (priceNode) priceNode.textContent = price;
    root.querySelectorAll('[data-obp-band-original]').forEach(function (node) { node.textContent = button.dataset.original || ''; node.style.display = button.dataset.original ? 'inline' : 'none'; });
    var stickyPrice = root.querySelector('[data-obp-band-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = price;
    var stickyLabel = root.querySelector('[data-obp-band-sticky-label]');
    if (stickyLabel) stickyLabel.textContent = label + ' · Tauscharmband';
    var availability = root.querySelector('[data-obp-band-availability]');
    if (availability) {
      availability.textContent = available ? 'Sofort verfügbar' : 'Derzeit nicht verfügbar';
      availability.classList.toggle('is-unavailable', !available);
    }
    var image = root.querySelector('[data-obp-band-image]');
    if (image && button.dataset.image) {
      image.src = button.dataset.image;
      image.removeAttribute('srcset');
      image.alt = button.dataset.imageAlt || label;
    }
    var buyButton = root.querySelector('[data-obp-band-buy]');
    var buyText = root.querySelector('[data-obp-band-buy-text]');
    var stickyButton = root.querySelector('[data-obp-band-sticky-submit]');
    if (buyButton) buyButton.disabled = !available;
    if (stickyButton) stickyButton.disabled = !available;
    if (buyText) buyText.textContent = available ? 'In den Warenkorb – ' + price + ' →' : 'Derzeit nicht verfügbar';
    try {
      var url = new URL(location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (_) {}
  }

  async function addBand(root) {
    var button = root.querySelector('[data-obp-band-buy]');
    var errorWrapper = root.querySelector('.product-form__error-message-wrapper');
    var errorMessage = errorWrapper && errorWrapper.querySelector('.product-form__error-message');
    var variantId = Number(root.dataset.variantId);
    if (!button || !variantId || button.disabled || button.classList.contains('loading')) return;
    button.classList.add('loading'); button.disabled = true; button.setAttribute('aria-busy', 'true');
    if (errorWrapper) errorWrapper.hidden = true;
    try {
      var response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Das Tauscharmband konnte nicht hinzugefügt werden.');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: result.items?.[0] || result } }));
      window.setTimeout(function () { document.getElementById('Cart-Drawer')?.open(); }, 100);
    } catch (error) {
      if (errorWrapper && errorMessage) { errorMessage.textContent = error.message || 'Bitte versuchen Sie es erneut.'; errorWrapper.hidden = false; }
    } finally {
      button.classList.remove('loading'); button.disabled = root.querySelector('[data-obp-band-option].is-selected')?.dataset.available !== 'true'; button.removeAttribute('aria-busy');
    }
  }

  function init(root) {
    if (!root || root.dataset.obpBandReady === 'true') return;
    root.dataset.obpBandReady = 'true';
    var form = root.querySelector('.obp-band__buy-form');
    if (form) form.addEventListener('submit', function (event) { event.preventDefault(); event.stopImmediatePropagation(); addBand(root); });
    var hero = root.querySelector('#bestellen');
    var sticky = root.querySelector('[data-obp-band-sticky]');
    if (sticky && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { var show = !entries[0].isIntersecting && window.innerWidth <= 640; sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show)); if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', ''); }, { threshold: .08 }).observe(hero);
    }
  }

  function initAll(container) { (container || document).querySelectorAll('[data-obp-band]').forEach(init); }
  if (!window.__obpBandV2ControlsReady) {
    window.__obpBandV2ControlsReady = true;
    document.addEventListener('click', function (event) {
      var option = event.target.closest('[data-obp-band-option]');
      var showcase = event.target.closest('[data-obp-band-showcase]');
      var control = event.target.closest('[data-obp-band-scroll], [data-obp-band-sticky-submit]');
      var root = event.target.closest('[data-obp-band]');
      if (!root) return;
      if (option) setVariant(root, option);
      if (showcase) { var match = root.querySelector('[data-obp-band-option][data-variant-id="' + showcase.dataset.obpBandShowcase + '"]'); if (match) setVariant(root, match); root.querySelector('#bestellen')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      if (control?.matches('[data-obp-band-scroll]')) root.querySelector('#bestellen')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (control?.matches('[data-obp-band-sticky-submit]')) addBand(root);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

